module.exports = __webpack_public_path__ + "static/favicons/mstile-144x144-71ae447c5b10415160c26071fb7c2d22.png";